module.exports = __webpack_public_path__ + "static/media/social-facebook.53ffe0c0.webp";